import VueRecaptcha from 'vue-recaptcha';
import routeService from '../../services/route_service.js';
import LoginService from '../../services/login_service.js';
import AlertService from '../../services/alert_service.js';

const loginService = new LoginService();
const alertService = new AlertService();

export default {
    name: 'Login',
    components: { VueRecaptcha },
    props: {
        msg: String
    },
    data: function() {
        return {
          data: {
            user: '',
            pass: '',
            recaptcha: ''
          },
          validacion: {
            user: {errores: ['El nombre de usuario es obligatorio'], estado: null},
            pass: {errores: [], estado: null},
            recaptcha: {errores: [], estado: null}
          },
          submited: false
        }
    },
    methods: {
		login() {       
			this.submited = true;
			this.validacion.user.errores.length = 0;
				if (typeof this.data.user == 'undefined' || this.data.user == '') {          
				this.validacion.user.errores.push('El nombre de usuario es obligatorio');
				this.validacion.user.estado = false;
				return;
			}

			if (typeof this.data.pass == 'undefined' || this.data.pass == '') {          
				this.validacion.pass.errores.push('La contraseña es obligatoria');
				this.validacion.pass.estado = false;
				return;
			}

			if (typeof this.data.recaptcha == 'undefined' || this.data.recaptcha == '') {          
				this.validacion.recaptcha.errores.push('La captcha es obligatorio');
				this.validacion.recaptcha.estado = false;
				return;
			}
			let _this = this;
			loginService.login({user: this.data.user, pass: this.data.pass, grecaptcharesponse: this.data.recaptcha}).then(function(response){
				let resp = response.body;
				if(!resp) {
					_this.limpiarCaptcha();
					alertService.showAlert(_this.$bvModal, 'warning', 'Error!', 'Se produjo un error al enviar los datos.');
					return;
				}
				if (resp.status && resp.status == "ERROR") {
					_this.limpiarCaptcha();
					alertService.showAlert(_this.$bvModal, 'warning', 'Error!', 'Nombre de usuario o contraseña incorrectos');
					return;
				} else if (resp.status && resp.status == "ERROR_CAPTCHA") {
					_this.limpiarCaptcha();
					alertService.showAlert(_this.$bvModal, 'warning', 'Error!', 'El captcha es inválido');
					return;
				}
				if (resp.length > 0 && resp[0].id !== undefined && resp[0].token !== undefined) {           
					loginService.setEstaLogueado(true);
					loginService.setToken(resp[0].token);       
					loginService.setUsrCentro(resp[0].centro);
					loginService.setUsrRoles(resp[0].roles);
					routeService.goToHome();
				} else {
					_this.limpiarCaptcha();
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Se produjo un error al obtener los datos de acceso');
				}
			}, function(error){
				alertService.showAlert(_this.$bvModal, 'danger', 'Error!', error.statusText);
			});
		},
		beforeCreate: function() {
			document.body.className = 'login';
		},
		onCaptchaVerified: function (recaptchaToken) {
			this.validacion.recaptcha.estado = null;
			this.data.recaptcha = recaptchaToken;
		},
		onCaptchaExpired: function () {
			this.limpiarCaptcha();
		},
		limpiarError: function (campo) {
			if (this.submited == false) {
			return true;
			}
			campo.errores.length = 0;
			campo.estado = null;
		},
		limpiarCaptcha() {
			this.$refs.recaptcha.reset();
			this.data.recaptcha = "";
		}
    },
}